import moment from 'moment'

export type GroupInterval = 'this_week' | 'this_month' | 'last_month' | 'all_time'

export const GROUP_INTERVAL_LABELS: Record<GroupInterval, string> = {
  this_week: 'This week',
  this_month: 'This month',
  last_month: 'Last month',
  all_time: 'All time',
}

export function getIntervalIsoRange(interval: GroupInterval): { startDate: string; endDate: string } {
  const now = moment.utc()
  switch (interval) {
    case 'this_week': {
      const start = now.clone().startOf('isoWeek')
      const end = now.clone().endOf('isoWeek')
      return { startDate: start.toISOString(), endDate: end.toISOString() }
    }
    case 'this_month': {
      const start = now.clone().startOf('month')
      const end = now.clone().endOf('month')
      return { startDate: start.toISOString(), endDate: end.toISOString() }
    }
    case 'last_month': {
      const ref = now.clone().subtract(1, 'month')
      const start = ref.clone().startOf('month')
      const end = ref.clone().endOf('month')
      return { startDate: start.toISOString(), endDate: end.toISOString() }
    }
    case 'all_time':
      return { startDate: moment.utc(0).toISOString(), endDate: now.toISOString() }
    default: {
      const start = now.clone().startOf('isoWeek')
      const end = now.clone().endOf('isoWeek')
      return { startDate: start.toISOString(), endDate: end.toISOString() }
    }
  }
}

export function formatGroupStatsRangeLabel(startIso: string, endIso: string): string {
  const start = moment.utc(startIso)
  const end = moment.utc(endIso)
  if (end.diff(start, 'years') > 10) {
    return 'All time'
  }
  return `${start.format('MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`
}
